import { createItemStorage } from "./createItemStorage";

export const priceItem = ({ storage }) => createItemStorage(storage, "selectedItem");
